export let lang = {};

export function setLanguage(locale) {
    return import(`./${locale}.js`)
        .then(module => {
            lang = module.default;
        })
        .catch(err => {
            // TODO: handle error
            console.log('There was a problem importing language file: ', err);  // TODO: figure out how to add this to en.js file
        });
}